import { z } from "zod";

export const transferSchema = z.object({
  payorId: z.string().min(1, { message: "Insurance provider is required" }),
});

export type TransferFormType = z.infer<typeof transferSchema>;
